import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import initApp from 'utils/functions/init';
import { getAuthCookieInfo } from 'utils/functions/authentication';
import { contexts } from 'constants/context';
import { fetchGetUserAddress } from 'modules/order/actions';
import BulkOrderView from 'modules/order/views/BulkOrderView';

// ###############################################################
// <------------------------ Constants -------------------------->
// ###############################################################
// ###############################################################
// <---------------------- End Constants ------------------------>
// ###############################################################
const BulkOrderPage = () => {
  // ###############################################################
  // <------------------------- Globals --------------------------->
  // ###############################################################
  const dispatch = useDispatch();
  const navigate = useNavigate();
  // ###############################################################
  // <----------------------- End Globals ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ useState --------------------------->
  // ###############################################################
  // ###############################################################
  // <---------------------- End useState ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ useEffect -------------------------->
  // ###############################################################
  useEffect(() => {
    const getUserAddressSuccessCallback = () => {
      navigate('/addAddress', { replace: true });
    };

    const { authToken } = getAuthCookieInfo();
    const body = {
      headers: {
        authorization: authToken,
      },
      callbackActionSuccess: getUserAddressSuccessCallback,
    };
    dispatch(fetchGetUserAddress(body));

    initApp(contexts.bulkOrder);
  }, [dispatch, navigate]);
  // ###############################################################
  // <---------------------- End useEffect ------------------------>
  // ###############################################################
  // ###############################################################
  // <--------------------- rest of hooks ------------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------- End rest of hooks ---------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------------- Logic ---------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ End Logic -------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------- Actions --------------------------->
  // ###############################################################
  // ###############################################################
  // <----------------------- End Actions ------------------------->
  // ###############################################################
  // ###############################################################
  // <----------------------- UI Handlers ------------------------->
  // ###############################################################
  // ###############################################################
  // <--------------------- End UI Handlers ----------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------------- Render --------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ End Render ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------- Return UI ------------------------->
  // ###############################################################
  return <BulkOrderView />;
  // ###############################################################
  // <----------------------- End Return UI ----------------------->
  // ###############################################################
};

BulkOrderPage.propTypes = {};

BulkOrderPage.defaultProps = {};

export default BulkOrderPage;
